import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { updateCity, updateRegion } from '../../../../actions';
import { useCityChangeApi } from './api';
import RegionCityList from '../../../components/global/regionCityList';

const CityChange = ({ user, updateCity, updateRegion, history, disableRedirect }) => {
  const { isOpen, onSubmit, currentCity, currentRegion, onSelectRegion, onSelectCity } = useCityChangeApi({
    user,
    updateCity,
    updateRegion,
    history,
    disableRedirect,
  });

  const isApp = !!window.ReactNativeWebView;
  const forceAuth = !user?.token && !!(isApp ? user?.edniproPopup?.app : user?.edniproPopup?.web);

  const canSubmit = currentRegion || currentCity;

  return (
    <Modal show={isOpen && !forceAuth} onHide={() => {}} className="modal-city" centered>
      <Modal.Header>
        <Modal.Title>Оберіть регіон або місто</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {user.initialCity && (
          <p style={{ fontSize: 14, color: '#555', marginBottom: 12 }}>
            Ми визначили ваш регіон як <strong>{user.initialCity.region?.name || user.initialCity.name}</strong>. Підтвердіть або оберіть інше.
          </p>
        )}
        <div style={{ border: '1px solid #d0e5f0', borderRadius: 8, overflow: 'hidden' }}>
          <RegionCityList
            regions={user.regions}
            cities={user.cities}
            currentRegion={currentRegion}
            currentCity={currentCity}
            onSelectRegion={onSelectRegion}
            onSelectCity={onSelectCity}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onSubmit} disabled={!canSubmit}>
          Зберегти
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = ({ user }) => ({ user });

const mapDispatchToProps = { updateCity, updateRegion };

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), withRouter);

export default enhance(CityChange);

